<template>
  <div class="light-gateway-content" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" :label="$t('gateway.name')"> </el-table-column>
        <el-table-column prop="number" :label="$t('gateway.number')"> </el-table-column>
        <el-table-column prop="type" :label="$t('gateway.type')">
          <template slot-scope="scope">
            {{typeArr[scope.row.type]}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('gateway.state')" prop="ste" width="140" align="center" sortable>
          <template slot-scope="scope">
            <i :class="steColorType[scope.row.ste]"></i>
            <span>{{ steType[scope.row.ste] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_env" :label="$t('gateway.env_sensor')">
          <template slot-scope="scope">
            {{envArr[scope.row.is_env]}}
          </template>
        </el-table-column>
        <el-table-column prop="is_env" :label="$t('gateway.tilt_sensor')">
          <template slot-scope="scope">
            {{envArr[scope.row.is_angle]}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('device.is_home')" prop="type">
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.is_env==1"
              v-model="scope.row.is_display"
              :active-value="1"
              :inactive-value="0"
              active-color="#67C23A"
              inactive-color="#aaaaaa"
              @change="changeSetHome(scope.row.id, scope.row.is_display)"
            />
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item :label="$t('gateway.name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gateway.number')" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gateway.type')" prop="type">
            <el-radio-group v-model="editOne.type">
              <template v-for="(item, index) in envArr">
                <el-radio v-if="index" :label="index" :key="index">{{item}}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="auto-item" :label="$t('gateway.env_sensor_install')" prop="type">
            <el-switch
              v-model="editOne.is_env"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              />
          </el-form-item>
          <el-form-item class="auto-item" :label="$t('gateway.tilt_sensor_install')" prop="type">
            <el-switch
              v-model="editOne.is_angle"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              />
          </el-form-item>
          <div class="map-container">
            <el-amap
              ref="map"
              vid="amap"
              :center="myMap.center"
              :zoom="myMap.zoom"
              :plugin="myMap.plugin"
              class="amap-demo"
              mapStyle="amap://styles/light"
              :events="myMap.events"
            >
              <el-amap-circle-marker
                :center="myMap.markercenter"
                :radius="myMap.radius"
                fillColor="gray"
                strokeColor="#fff"
                :fillOpacity="myMap.fillOpacity"
              >
              </el-amap-circle-marker>
            </el-amap>
          </div>
          <el-form-item :label="$t('control.longitude')" prop="longitude">
            <el-input v-model="editOne.longitude"></el-input>
          </el-form-item>
          <el-form-item :label="$t('control.latitude')" prop="latitude">
            <el-input v-model="editOne.latitude"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import netWorkApi from "@/api/device/network";
import { ACCOUNT_MAP } from '@/config/index.js';
export default {
  data() {
    return {
      myMap: {
        center: [],
        markercenter: [],
        events: {
          mapmove: () => {
            this.handleMove();
          },
        },
        zoom: 18,
        radius: 10,
        fillOpacity: 1,
      },
      loading: false,
      dialogVisible: false,
      typeArr: this.$t('gateway.typeArr'),
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      steType: this.$t('device.steList'),
      envArr: this.$t('gateway.envArr'),
      steColorType: ["valuered", "valuegreen"],
      editOneRule: {
        name: [{ required: true, message: this.$t('device.please_name'), trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        name: '',
        number: '',
        type: 1,
        is_env: 0,
        is_angle: 0,
        longitude: '',
        latitude: ''
      }
    };
  },
  mounted() {
    let mapData = ACCOUNT_MAP
    const mapDataStr = localStorage.getItem('mapData');
    if(mapDataStr){
      mapData = JSON.parse(mapDataStr)
    }
    this.myMap.center = mapData.center
    this.myMap.markercenter = mapData.center

    this.getTableData(this.pageInfo.page);
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      netWorkApi.netWorkList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: '',
          type: 1,
          is_env: 0,
          is_angle: 0,
          longitude: '',
          latitude: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number,
          type: index.type,
          is_env: index.is_env,
          is_angle: index.is_angle,
          longitude:index.longitude,
          latitude:index.latitude,
        };
        let lng = index.longitude
        let lat = index.latitude
        let lngLat = [lng, lat]
        if(lng&&lat){
          this.myMap.center = lngLat
          this.myMap.markercenter = lngLat
        }
        
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      netWorkApi.netWorkEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      netWorkApi.netWorkAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          netWorkApi.netWorkDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    handleMove() {
      this.myMap.markercenter = this.$refs.map.$$getCenter();
      this.editOne.longitude = this.myMap.markercenter[0];
      this.editOne.latitude = this.myMap.markercenter[1];
    },
    changeSetHome(id, value) { //设置首页显示
      netWorkApi.networkSetHome(id,{ is_display: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.set_success'));
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>
<style lang='less'>
.light-gateway-content{
  width: 100%;
  .map-container {
    padding-left: 100px;
    height: 180px;
    margin-bottom: 10px;
  }
  .form-info{
    padding: 0;
    .el-form-item__label{
      width:90px;
    }
  }
}

</style>